
import React, { FC } from 'react'
import Grid from '../../atoms/Grid'

interface IProps { }

/**
* @author
* @function @
**/

export const MoveOutList = React.memo((props: any) => {
    const { columns, data, gridProps } = props
    return (
        <Grid
            columns={columns}
            pagination={false}
            defaultSettings={gridProps}
            noRowlabel="Contract"
            fullPage={true}
            data={data ?? []}
        />
    )
})
